var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1284.88 458.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 2.06px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n        stroke: #08c4d6;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        fill: #08c4d6;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        stroke-width: 2.37px;\n      }\n\n      .cls-4 {\n        stroke-width: 3.38px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "index"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 480.3,
    y1: 149.68,
    x2: 529.69,
    y2: 149.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M529.49,153.74c2.24,0,4.06-1.82,4.06-4.06s-1.82-4.06-4.06-4.06-4.06,1.82-4.06,4.06,1.82,4.06,4.06,4.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 776.3,
    y1: 453.33,
    x2: 706.19,
    y2: 453.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M706.43,448.53c-2.66,0-4.81,2.15-4.81,4.81s2.15,4.81,4.81,4.81,4.81-2.15,4.81-4.81-2.15-4.81-4.81-4.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1051 103.62 963.78 103.62 943.5 123.9 943.5 167.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M938.69,167.68c0,2.66,2.15,4.81,4.81,4.81s4.81-2.15,4.81-4.81-2.15-4.81-4.81-4.81-4.81,2.15-4.81,4.81Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1051 55.6 1013.41 55.6 980.77 22.96 980.56 .01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "126.8 442.34 48.58 442.34 25.31 419.06 0 419.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "126.8 424.17 48.58 424.17 25.31 400.89 25.62 301.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1145.75 192.22 1145.75 227.47 1170.87 252.59 1282.38 252.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1050.75 309.46 1050.75 288.3 1073.09 265.96 1284.88 265.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1038.88 309.46 1038.88 287.71 1074.47 252.11 1117.22 252.11 1132.88 227.98 1132.88 192.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1157.1 192.22 1157.1 222.41 1174.14 239.45 1282.38 239.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 314.54,
    y1: 332.21,
    x2: 314.54,
    y2: 289.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "324.65 332.21 324.65 314.21 335.61 303.25 546.57 303.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M546.37,307.26c2.21,0,4.01-1.79,4.01-4.01s-1.79-4.01-4.01-4.01-4.01,1.79-4.01,4.01,1.79,4.01,4.01,4.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1051 79.21 1015.78 79.21 986.37 49.8 718.52 49.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M718.74,45.43c-2.41,0-4.36,1.95-4.36,4.36s1.95,4.36,4.36,4.36,4.36-1.95,4.36-4.36-1.95-4.36-4.36-4.36Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats4);
export default __webpack_public_path__ + "static/media/stats 4.b9a98a6ad751f6c6ff0a664a15ed8cdc.svg";
export { ForwardRef as ReactComponent };